import PropTypes from "prop-types";
import "./AdsHistory.scss";

const currencyFormatter = new Intl.NumberFormat("es-ES", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});

function formatValue(field, value) {
  if (value === null || value === undefined || value === "") return "—";
  if (Array.isArray(value)) return value.join(", ");
  if (typeof value === "object")
    return value.name || value.fullName || value._id || JSON.stringify(value);
  if (typeof value === "number") {
    // Heuristic: if field mentions sale or rent, format as currency
    if (/(sale|rent|price|value)/i.test(field))
      return currencyFormatter.format(value);
    return String(value);
  }
  return String(value);
}

function buildSentence(entry, dateStr) {
  const { type, field, oldValue, newValue, consultant, note } = entry;
  const by =
    consultant && consultant.fullName ? (
      <>
        {" "}
        — por <strong>{consultant.fullName}</strong>
      </>
    ) : null;

  const oldVal = <strong>{formatValue(field, oldValue)}</strong>;
  const newVal = <strong>{formatValue(field, newValue)}</strong>;

  switch (type) {
    case "CREATION":
      if (
        note === "Creación sintética del campo" ||
        note === "Synthetic creation entry"
      ) {
        if (!consultant)
          return (
            <>
              Fecha de creación <strong>{dateStr}</strong>
            </>
          );
        // if there is a consultant, show note + by
        return note ? (
          <>
            {note}
            {by}
          </>
        ) : (
          <>Se creó el anuncio{by}</>
        );
      }
      return note ? (
        <>
          {note}
          {by}
        </>
      ) : (
        <>Se creó el anuncio{by}</>
      );
    case "PRICE_CHANGE":
      return (
        <>
          Cambio de precio de {oldVal} a {newVal}
          {by}
        </>
      );
    case "OWNER_CHANGE":
      return (
        <>
          Cambio de propietario de {oldVal} a {newVal}
          {by}
        </>
      );
    case "ADTYPE_CHANGE":
      return (
        <>
          Cambio de tipo de anuncio de {oldVal} a {newVal}
          {by}
        </>
      );
    case "GV_OPERATION_CHANGE":
      return (
        <>
          Cambio de estado de operación de {oldVal} a {newVal}
          {by}
        </>
      );
    case "OTHER":
    default:
      return (
        <>
          Cambio en {field}: {oldVal} → {newVal}
          {by}
        </>
      );
  }
}

export default function AdsHistory({ ad }) {
  const history = (ad && ad.changesHistory) || [];

  if (!history || history.length === 0) return null;

  // sort by date desc
  const sorted = [...history].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  return (
    <div className="AdsHistory">
      {sorted.map((entry) => {
        const id = entry._id || entry.id || `${entry.date}`;
        const dateStr = entry.date
          ? new Date(entry.date).toLocaleString("es-ES", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
          : "";

        return (
          <div className="AdsHistory__item" key={id}>
            <div className="AdsHistory__content">
              <div className="AdsHistory__summary">
                {buildSentence(entry, dateStr)}
              </div>
              {entry.note ? (
                <div className="AdsHistory__note">{entry.note}</div>
              ) : null}
            </div>
            <div className="AdsHistory__date">{dateStr}</div>
          </div>
        );
      })}
    </div>
  );
}

AdsHistory.propTypes = {
  ad: PropTypes.object,
};
// end of AdsHistory component
